<template>
  <global-dialog-card
    v-model="model"
    :title="invoice ? $t('finance_invoice_title', { number: invoice.number }) : ''"
    hide-actions
    max-width="440"
  >
    <div v-if="invoice" class="detail-rows">
      <div class="detail-row">
        <span class="font-weight-medium">{{ $t("finance_line_items") }}</span>
      </div>
      <div v-for="item in invoice.lineItems" :key="item.description" class="line-item-row">
        <span>{{ item.description }}</span>
        <strong>{{ formatCurrency(item.amount) }}</strong>
      </div>
      <div class="line-item-row deduction">
        <span>{{ $t("finance_vat") }}</span>
        <strong>{{ formatCurrency(invoice.vat) }}</strong>
      </div>

      <v-divider class="my-2" />

      <div class="detail-row total">
        <span>{{ $t("finance_total") }}</span>
        <strong class="success--text">{{ formatCurrency(invoice.amount) }}</strong>
      </div>

      <v-divider class="my-2" />

      <div class="meta-row">
        <span>{{ $t("finance_payment_method_label") }}</span>
        <strong>{{ invoice.paymentMethod }}</strong>
      </div>
      <div class="meta-row">
        <span>{{ $t("finance_due_date_label") }}</span>
        <strong>{{ localeDate(invoice.dueDate) }}</strong>
      </div>
      <div class="meta-row">
        <span>IBAN</span>
        <strong class="mono">{{ invoice.iban }}</strong>
      </div>

      <div class="qr-row">
        <div class="qr-box">
          <v-icon size="40">mdi-qrcode</v-icon>
        </div>
        <span class="qr-label">{{ $t("finance_qr_payment_label") }}</span>
      </div>
    </div>
  </global-dialog-card>
</template>

<script>
import hasModel from "@/mixins/hasModel";
import GlobalDialogCard from "@/components/global/GlobalDialogCard.vue";

export default {
  name: "InvoiceDetailDialog",

  components: { GlobalDialogCard },

  mixins: [hasModel],

  props: {
    invoice: {
      type: Object,
      default: null,
    },
  },

  methods: {
    formatCurrency(amount) {
      const value = Number(amount) || 0;
      return `${value.toFixed(2)} ${this.restaurantCurrency}`;
    },
  },
};
</script>

<style scoped>
.detail-rows {
  display: grid;
  gap: 6px;
}

.detail-row,
.meta-row,
.line-item-row {
  display: flex;
  justify-content: space-between;
  font-size: 0.88rem;
}

.line-item-row.deduction {
  color: rgba(0, 0, 0, 0.6);
}

.detail-row.total {
  font-size: 1.05rem;
}

.meta-row {
  color: rgba(0, 0, 0, 0.6);
}

.mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 0.8rem;
}

.qr-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 16px;
}

.qr-box {
  width: 64px;
  height: 64px;
  border-radius: 12px;
  background: #f2f3f7;
  display: flex;
  align-items: center;
  justify-content: center;
}

.qr-label {
  font-size: 0.82rem;
  color: rgba(0, 0, 0, 0.6);
}
</style>
